import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetInvoiceSidebarQueryVariables = Types.Exact<{
  rooftopId?: Types.InputMaybe<Types.Scalars['bigint']['input']>;
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
}>;


export type GetInvoiceSidebarQuery = { __typename?: 'query_root', arinvoices: Array<{ __typename?: 'arinvoices', id: number, invoice_type: string, status: string, start_datetime: string, end_datetime: string, customer?: { __typename?: 'customers', id: number, name?: string | null } | null, armoves: Array<{ __typename?: 'armoves', id: number, active: number, due_amount: number, paid_amount: number, discount_amount: number, discount_reason?: string | null, disputed: boolean, dispute_reason?: string | null, type: string }>, arpayments: Array<{ __typename?: 'arpayments', id: number, status: string, amount: number }> }> };


export const GetInvoiceSidebarDocument = gql`
    query getInvoiceSidebar($rooftopId: bigint, $start: timestamptz!, $end: timestamptz!) {
  arinvoices(
    where: {customer_id: {_eq: $rooftopId}, _or: [{start_datetime: {_gte: $start, _lte: $end}}, {end_datetime: {_gte: $start, _lte: $end}}]}
    order_by: {start_datetime: desc}
  ) {
    id
    invoice_type
    status
    start_datetime
    end_datetime
    customer {
      id
      name
    }
    armoves(where: {active: {_eq: 1}}, order_by: {id: asc}) {
      id
      active
      due_amount
      paid_amount
      discount_amount
      discount_reason
      disputed
      dispute_reason
      type
    }
    arpayments {
      id
      status
      amount
    }
  }
}
    `;

/**
 * __useGetInvoiceSidebarQuery__
 *
 * To run a query within a React component, call `useGetInvoiceSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceSidebarQuery({
 *   variables: {
 *      rooftopId: // value for 'rooftopId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetInvoiceSidebarQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceSidebarQuery, GetInvoiceSidebarQueryVariables> & ({ variables: GetInvoiceSidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceSidebarQuery, GetInvoiceSidebarQueryVariables>(GetInvoiceSidebarDocument, options);
      }
export function useGetInvoiceSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceSidebarQuery, GetInvoiceSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceSidebarQuery, GetInvoiceSidebarQueryVariables>(GetInvoiceSidebarDocument, options);
        }
// @ts-ignore
export function useGetInvoiceSidebarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoiceSidebarQuery, GetInvoiceSidebarQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceSidebarQuery, GetInvoiceSidebarQueryVariables>;
export function useGetInvoiceSidebarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceSidebarQuery, GetInvoiceSidebarQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceSidebarQuery | undefined, GetInvoiceSidebarQueryVariables>;
export function useGetInvoiceSidebarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceSidebarQuery, GetInvoiceSidebarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoiceSidebarQuery, GetInvoiceSidebarQueryVariables>(GetInvoiceSidebarDocument, options);
        }
export type GetInvoiceSidebarQueryHookResult = ReturnType<typeof useGetInvoiceSidebarQuery>;
export type GetInvoiceSidebarLazyQueryHookResult = ReturnType<typeof useGetInvoiceSidebarLazyQuery>;
export type GetInvoiceSidebarSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceSidebarSuspenseQuery>;
export type GetInvoiceSidebarQueryResult = Apollo.QueryResult<GetInvoiceSidebarQuery, GetInvoiceSidebarQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/invoices/queries/getInvoiceSidebar.query.gql}
 */
export async function getInvoiceSidebar(
  variables: GetInvoiceSidebarQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetInvoiceSidebarQuery['arinvoices']>
export async function getInvoiceSidebar(
  variables: GetInvoiceSidebarQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetInvoiceSidebarQuery>
export async function getInvoiceSidebar(
  variables: GetInvoiceSidebarQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetInvoiceSidebarQuery['arinvoices'] | GetInvoiceSidebarQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetInvoiceSidebarQuery>(
    GetInvoiceSidebarDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.arinvoices
}